/**
 * Verona Tempo — collection + search listing features (round 9 T3). Vanilla JS, no dependencies.
 * Loaded (deferred) ONLY on collection and search templates, right after assets/vt-theme.js (layout/theme.liquid),
 * so it runs after all the global features and uses their shared helpers from window.vtCore (top of vt-theme.js).
 * Product card features (sizes, compare, wishlist hearts, tap equivalents) stay in vt-theme.js: cards are everywhere.
 *  - Phones: 1 or 2 products per row, remembered (D3) — also re-applied after filters / sort re-draw the list
 *  - "Load more" button (real page links stay for Google / no JavaScript) (U8)
 *  - "Show my size (38)" chip on collections — a suggestion, never applied by itself (U9)
 *  - Back to the same place on a collection (with its "Load more" pages) after the back button (U10)
 *  Round 9:
 *  - Filter drawer on phones/tablets (T5): dialog role, focus kept inside, Escape closes, focus back on the
 *    "Filter" button, aria-expanded on the Filter buttons and on each filter group heading (Enter + Space)
 *  - "Products updated" read out after filters / sort change the list (T5)
 *  - Search page: clear button in the big search field (D6); "Load more" also on search
 *  - Phone 1-per-row: card photos say "full width" in their sizes (T9)
 *  - sessionStorage "vt-listing-order" = { handle, title, url, items: [{ handle, url, title }] } — the products listed
 *    on this collection page, in order, with "Load more" pages (the product page uses it for next / previous)
 *  Round 10:
 *  - Filter bar with dropdowns on computers / bottom sheet on phones (initFilterBar; setting vt_r10_filter_bar),
 *    the "Size" pill (initMySizePill), the page behind the open sheet is inert
 *  - "Load more": the next page is fetched once when the page is idle (not on Save-Data / 2G), shown on tap
 *  - Back to the same place also after filtering / sorting (the address is read when leaving)
 * Config + translated strings: window.vtConfig (snippets/vt-config.liquid) — the same object as vtCore.cfg;
 * collection/search extras in vtConfig.collection (snippets/vt-collection-config.liquid).
 */
(function () {
  'use strict';

  var core = window.vtCore;
  if (!core) return; // vt-theme.js did not run

  var cfg = core.cfg;
  var S = core.S;
  var tpl = core.tpl;
  var esc = core.esc;
  var announce = core.announce;
  var storageGet = core.storageGet;
  var storageSet = core.storageSet;
  var readSizeMemory = core.readSizeMemory;
  var isSizeOption = core.isSizeOption;
  var onListingRefresh = core.onListingRefresh;
  var CC = cfg.collection || {};
  var CS = CC.strings || {};

  /* ---- D3: phones — 1 or 2 products per row, remembered ------------------- */
  var GRID_KEY = 'vt-grid-mob';
  function listingGrids() {
    return document.querySelectorAll('filter-container .product-grid');
  }
  var SIZES_TWO = 'calc((100vw - 44px) / 2)';
  var SIZES_ONE = 'calc(100vw - 32px)';
  function fixCardSizes(grid, mode) {
    // r9 (T9): the listing card photos end their "sizes" with the phone width of one card
    grid.querySelectorAll('img[sizes]').forEach(function (img) {
      var z = img.getAttribute('sizes') || '';
      var n = mode === '1' ? z.replace(SIZES_TWO, SIZES_ONE) : z.replace(SIZES_ONE, SIZES_TWO);
      if (n !== z) img.setAttribute('sizes', n);
    });
  }
  function applyGridMode(mode) {
    if (mode !== '1' && mode !== '2') return;
    listingGrids().forEach(function (grid) {
      grid.classList.remove('product-grid--per-row-mob-1', 'product-grid--per-row-mob-2');
      grid.classList.add('product-grid--per-row-mob-' + mode);
      fixCardSizes(grid, mode);
    });
    document.querySelectorAll('[data-vt-grid]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.vtGrid === mode ? 'true' : 'false');
    });
  }
  function currentGridMode() {
    var saved = storageGet('localStorage', GRID_KEY);
    if (saved === '1' || saved === '2') return saved;
    var grid = listingGrids()[0];
    return grid && grid.classList.contains('product-grid--per-row-mob-1') ? '1' : '2';
  }
  function initGridSwitch() {
    if (!document.querySelector('[data-vt-grid]')) return;
    applyGridMode(currentGridMode());
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest && evt.target.closest('[data-vt-grid]');
      if (!btn) return;
      evt.preventDefault();
      var mode = btn.dataset.vtGrid;
      storageSet('localStorage', GRID_KEY, mode);
      applyGridMode(mode);
      announce(mode === '1' ? S.gridOne : S.gridTwo);
    });
  }

  /* ---- U8: "Load more" (real page links stay for Google / no JavaScript) --- */
  function loadMoreFetchUrl(url) {
    var fc = document.querySelector('filter-container');
    var sectionId = fc && fc.dataset.filterSectionId;
    return url + (sectionId ? (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId) : '');
  }
  /* r10: the next "Load more" page is fetched once when the page is idle (not on Save-Data / 2G) and kept
     until she taps the button (nothing is drawn before). Never more than one page ahead. */
  var preloaded = null; // { url, promise }
  function slowNetwork() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(String(c.effectiveType || ''))));
  }
  function preloadNextPage() {
    if (slowNetwork()) return;
    var run = function () {
      var btn = document.querySelector('[data-vt-load-more]');
      var url = btn && btn.dataset.nextUrl;
      if (!url || (preloaded && preloaded.url === url)) return;
      var entry = { url: url, promise: null };
      entry.promise = fetch(loadMoreFetchUrl(url), { headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
      entry.promise.catch(function () { if (preloaded === entry) preloaded = null; });
      preloaded = entry;
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 5000 });
    else window.setTimeout(run, 2000);
  }
  function initLoadMore() {
    if (document.querySelector('[data-vt-load-more]')) {
      if (document.readyState === 'complete') preloadNextPage();
      else window.addEventListener('load', preloadNextPage, { once: true });
    }
    // filters / sort drew a new list: the kept page is for the old list
    onListingRefresh(function () { preloaded = null; preloadNextPage(); });
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest && evt.target.closest('[data-vt-load-more]');
      if (!btn) return;
      evt.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      var url = btn.dataset.nextUrl;
      var grid = document.querySelector('filter-container .collection-listing .product-grid');
      var row = btn.closest('.pagination-row');
      if (!url || !grid || !row) { window.location.href = url; return; }
      var fetchUrl = loadMoreFetchUrl(url);
      var label = btn.querySelector('[data-vt-load-more-label]') || btn;
      var original = label.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.remove('vt-load-more__btn--retry');
      btn.classList.add('is-loading');
      label.textContent = S.loadingMore;
      var fresh = function () {
        return fetch(fetchUrl, { headers: { Accept: 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
      };
      var cached = preloaded && preloaded.url === url ? preloaded.promise : null;
      preloaded = null;
      (cached ? cached.catch(fresh) : fresh())
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var newGrid = tmp.querySelector('.collection-listing .product-grid');
          var newRow = tmp.querySelector('.pagination-row');
          var blocks = newGrid ? Array.prototype.slice.call(newGrid.children) : [];
          // 8 Oct 2026: a page can come back with no cards when all its pieces were already shown higher up (new
          // pieces first, e.g. Boots page 4) — move on to the next page / finish instead of opening the empty page
          if (!blocks.length) {
            if (!newRow) throw new Error('empty');
            row.innerHTML = newRow.innerHTML;
            document.dispatchEvent(new CustomEvent('vt:products:appended', { detail: { count: 0 } }));
            preloadNextPage();
            return;
          }
          blocks.forEach(function (el) {
            // show straight away (the scroll animation would keep late-added cards invisible)
            el.querySelectorAll('[data-cc-animate]').forEach(function (a) { a.removeAttribute('data-cc-animate'); });
            grid.appendChild(el);
          });
          if (newRow) row.innerHTML = newRow.innerHTML;
          // r10: the sizes of the new products (filter bar "Size" pill)
          var newMap = tmp.querySelector('[data-vt-size-map]');
          if (newMap && grid.parentNode) grid.parentNode.appendChild(newMap);
          // r9 (D6): search — categories & pages of the next page join the list at the top
          var otherList = document.querySelector('filter-container [data-vt-search-other]');
          var newOther = tmp.querySelector('[data-vt-search-other]');
          if (otherList && newOther) {
            Array.prototype.slice.call(newOther.children).forEach(function (li) { otherList.appendChild(li); });
          }
          var mode = storageGet('localStorage', GRID_KEY);
          if (mode) applyGridMode(mode);
          var firstLink = blocks[0].querySelector('.product-block__detail a.product-link, a');
          if (firstLink) firstLink.focus({ preventScroll: true });
          var countEl = row.querySelector('[data-vt-load-more-count]');
          announce(tpl(S.loadedMore, { count: blocks.length }) + (countEl ? '. ' + countEl.textContent.trim() : ''));
          if (window.vtDrawCardLists) window.vtDrawCardLists();
          document.dispatchEvent(new CustomEvent('vt:products:appended', { detail: { count: blocks.length } }));
          preloadNextPage(); // r10: keep the next one ready
        })
        .catch(function (err) {
          // nothing more to show: just end the list (never open an empty page)
          if (err && err.message === 'empty') {
            var more = row.querySelector('.vt-load-more');
            if (more) more.parentNode.removeChild(more);
            document.dispatchEvent(new CustomEvent('vt:products:appended', { detail: { count: 0 } }));
            return;
          }
          // 8 Oct 2026: a dropped connection no longer opens "page N" (she lost her place in the list); the button
          // stays and says it couldn't load, so one tap tries again
          btn.classList.add('vt-load-more__btn--retry');
          original = S.loadFailed || 'Could not load more – tap to try again';
          document.dispatchEvent(new CustomEvent('vt:products:loadfail'));
        })
        .finally(function () {
          if (!btn.isConnected) return;
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-loading');
          label.textContent = original;
        });
    });
  }

  /* ---- U9: "Show my size (38)" — a suggestion, never applied by itself ----
     Uses the store's Size filter when the collection has one (Search & Discovery); otherwise it shows
     only the loaded cards that have her size in stock (card data, no extra requests) and can be undone. */
  function initSizeChip() {
    if (!cfg.sizeChip || !document.body.classList.contains('template-collection')) return;
    if (document.querySelector('[data-vt-fbar]')) { initMySizePill(); return; } // r10: lives in the filter bar
    var active = false;
    var cardHasSize = function (block, size) {
      var box = block.querySelector('[data-vt-card-sizes]');
      if (!box) return false;
      var data;
      try { data = JSON.parse(box.dataset.vtSizes || '[]'); } catch (e) { return false; }
      return data.some(function (run) { return String(run && run[1] || '').split('|').indexOf(size) > -1; });
    };
    var applyLocal = function (size) {
      var shown = 0;
      document.querySelectorAll('filter-container .collection-listing product-block').forEach(function (b) {
        var ok = !active || cardHasSize(b, size);
        b.classList.toggle('vt-size-hide', !ok);
        if (ok) shown += 1;
      });
      return shown;
    };
    var run = function () {
      var size = readSizeMemory().shoes;
      var bar = document.querySelector('.utility-bar:not(.utility-bar--sticky-mobile-copy)');
      if (!size || !bar || bar.querySelector('.vt-size-chip')) return;
      active = false;
      var form = document.getElementById('CollectionFilterForm');
      var input = form ? Array.prototype.slice.call(form.querySelectorAll('input[type="checkbox"][name^="filter.v.option."]')).filter(function (i) {
        var name = i.name.toLowerCase();
        return i.value === size && (name.indexOf('size') > -1 || name.indexOf('taille') > -1 || name.indexOf('مقاس') > -1 || isSizeOption(name.replace('filter.v.option.', '')));
      })[0] : null;
      if (input && (input.checked || input.disabled)) return;
      if (!input) {
        // no Size filter on this collection: offer the on-page version only for shoe grids
        var blocks = document.querySelectorAll('filter-container .collection-listing product-block');
        var withSizes = document.querySelectorAll('filter-container .collection-listing product-block [data-vt-card-sizes]').length;
        if (!blocks.length || withSizes < 3) return;
      }
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'vt-size-chip';
      chip.setAttribute('aria-pressed', 'false');
      var icon = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12.5l5 5L20 6.5"/></svg>';
      var label = function () { chip.innerHTML = icon + '<span>' + esc(active ? S.showAllSizes : tpl(S.showMySize, { size: size })) + '</span>'; };
      label();
      chip.addEventListener('click', function () {
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          chip.remove();
          announce(tpl(S.showingMySize, { size: size }));
          return;
        }
        active = !active;
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
        chip.classList.toggle('is-active', active);
        var n = applyLocal(size);
        label();
        announce(active ? tpl(S.sizeOnPage, { size: size, count: n }) : S.showAllSizesDone);
      });
      var slot = bar.querySelector('.utility-bar__left') || bar;
      slot.appendChild(chip);
    };
    run();
    onListingRefresh(run);
    document.addEventListener('vt:products:appended', function () {
      var size = readSizeMemory().shoes;
      if (active && size) applyLocal(size);
    });
  }

  /* ---- r10: filter bar with dropdowns (computers) / bottom sheet (phones) ------------------
     snippets/faceted-filters.liquid (setting vt_r10_filter_bar). The pills are real buttons; one panel open at a
     time on computers (click / tap / Enter / Space; Escape, a click outside or tabbing away closes it; focus goes
     into the panel and back to the pill). On phones the same groups fold open / shut inside the sheet.
     Symmetry redraws the whole bar after each change (its data-ajax-container): the open panel, the folded groups
     and the focused choice are put back. */
  var BAR_MQ = window.matchMedia ? window.matchMedia('(min-width: 1000px)') : { matches: true };
  var barI18n = null;
  function fbarText(key, vals) {
    if (!barI18n) {
      var el = document.querySelector('[data-vt-fbar-i18n]');
      try { barI18n = el ? JSON.parse(el.textContent) : {}; } catch (e) { barI18n = {}; }
    }
    return tpl(barI18n[key] || '', vals || {});
  }
  function initFilterBar() {
    var fc = document.querySelector('filter-container');
    var bar = fc && fc.querySelector('[data-vt-fbar]');
    if (!bar) return;
    var inner = bar.querySelector('.filters__inner');
    var openKey = null; // computers: the open panel
    var mobOpen = {};   // phones: groups she opened / closed herself
    var lastFocusId = null;
    var closeAfterRender = false;
    var desk = function () { return BAR_MQ.matches; };
    var groups = function () { return Array.prototype.slice.call(bar.querySelectorAll('[data-vt-fgroup]')).filter(function (g) { return g.querySelector('[data-vt-fpill]'); }); };
    var groupOf = function (key) { return groups().filter(function (g) { return g.dataset.vtFgroup === key; })[0] || null; };
    var mobDefault = function (g) {
      return g.classList.contains('has-chosen') || /--(colour|size|mysize|sort)\b/.test(g.className);
    };
    var setState = function (g, open) {
      var pill = g.querySelector('[data-vt-fpill]');
      g.classList.toggle(desk() ? 'is-open' : 'is-open-m', open);
      g.classList.remove(desk() ? 'is-open-m' : 'is-open');
      if (pill) pill.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    var apply = function () {
      if (!desk()) openKey = null;
      groups().forEach(function (g) {
        var key = g.dataset.vtFgroup;
        var open = desk() ? key === openKey : (key in mobOpen ? mobOpen[key] : mobDefault(g));
        setState(g, open);
      });
    };
    var firstIn = function (g) {
      var panel = g.querySelector('.vt-fbar__panel');
      if (!panel) return null;
      return panel.querySelector('input:checked:not([disabled])') ||
        panel.querySelector('input:not([disabled]):not([type="hidden"]), button:not([disabled]), a[href]');
    };
    var closeDesk = function (returnFocus) {
      if (!openKey) return;
      var g = groupOf(openKey);
      openKey = null;
      if (!g) return;
      setState(g, false);
      if (returnFocus) {
        var pill = g.querySelector('[data-vt-fpill]');
        if (pill) pill.focus({ preventScroll: true });
      }
    };
    var openDesk = function (g) {
      closeDesk(false);
      openKey = g.dataset.vtFgroup;
      setState(g, true);
      var f = firstIn(g);
      if (f) f.focus({ preventScroll: true });
    };
    fc.addEventListener('click', function (evt) {
      var pill = evt.target.closest && evt.target.closest('[data-vt-fpill]');
      if (!pill || !bar.contains(pill)) return;
      evt.preventDefault();
      var g = pill.closest('[data-vt-fgroup]');
      if (desk()) {
        if (openKey === g.dataset.vtFgroup) closeDesk(true); else openDesk(g);
      } else {
        var open = pill.getAttribute('aria-expanded') !== 'true';
        mobOpen[g.dataset.vtFgroup] = open;
        setState(g, open);
      }
    });
    // arrow down on a pill opens its panel too
    fc.addEventListener('keydown', function (evt) {
      var pill = evt.target.closest && evt.target.closest('[data-vt-fpill]');
      if (pill && desk() && evt.key === 'ArrowDown' && pill.getAttribute('aria-expanded') !== 'true') {
        evt.preventDefault();
        openDesk(pill.closest('[data-vt-fgroup]'));
      }
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Escape' || !desk() || !openKey) return;
      evt.preventDefault();
      evt.stopPropagation();
      closeDesk(true);
    }, true);
    document.addEventListener('click', function (evt) {
      if (!openKey || !desk()) return;
      var g = groupOf(openKey);
      if (g && !g.contains(evt.target)) closeDesk(false);
    });
    bar.addEventListener('focusout', function (evt) {
      if (!openKey || !desk()) return;
      var g = groupOf(openKey);
      var to = evt.relatedTarget;
      if (g && to && !g.contains(to)) closeDesk(false);
    });
    bar.addEventListener('focusin', function (evt) { if (evt.target.id) lastFocusId = evt.target.id; });
    // a new sort order closes its panel (the list changes a lot); other choices keep the panel open
    bar.addEventListener('change', function (evt) {
      if (evt.target && evt.target.name === 'sort_by' && desk()) closeAfterRender = true;
    });
    // Symmetry redrew the bar
    if (inner && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (closeAfterRender) { closeAfterRender = false; var k = openKey; openKey = null; apply(); var g = k && groupOf(k); var p = g && g.querySelector('[data-vt-fpill]'); if (p) p.focus({ preventScroll: true }); }
        else apply();
        if (openKey && desk() && lastFocusId) {
          var el = document.getElementById(lastFocusId);
          var g2 = groupOf(openKey);
          if (el && g2 && g2.contains(el)) el.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('vt:filterbar:render'));
      }).observe(inner, { childList: true });
    }
    if (BAR_MQ.addEventListener) BAR_MQ.addEventListener('change', function () { openKey = null; apply(); });
    apply();
  }

  /* ---- r10: "Size" in the filter bar --------------------------------------------------------------
     - the store has a Size filter (Search & Discovery): the size pills are Shopify's; if she picked a size before,
       a "Your size: 38" button at the top of that panel ticks it.
     - no Size filter yet: the "Size" pill is the round-6 "In stock in my size" helper. It says clearly that it only
       checks the shoes shown on the page (and those added with "Load more") — it is not a full filter. Nothing is
       hidden until she chooses. The pill then reads "My size: 38 (in stock)". Back from a product keeps it on. */
  var MYSIZE_KEY = 'vt-mysize-on';
  function initMySizePill() {
    var active = false;
    var here = function () { return window.location.pathname + window.location.search; };
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (nav && nav.type === 'back_forward') {
      try {
        var st = JSON.parse(storageGet('sessionStorage', MYSIZE_KEY) || 'null');
        active = !!(st && st.on && st.url === here() && readSizeMemory().shoes);
      } catch (e) { active = false; }
    }
    var remember = function () {
      storageSet('sessionStorage', MYSIZE_KEY, JSON.stringify({ url: here(), on: active }));
    };
    // sizes of a card: the card's own size data (round-9 cards) or the page's size list (main-collection.liquid,
    // data-vt-size-map: { handle: ["|in stock|", "|all|"] }) — the round-10 clean cards may not carry sizes
    var mapCache = null;
    var sizeMap = function () {
      if (mapCache) return mapCache;
      mapCache = {};
      document.querySelectorAll('filter-container [data-vt-size-map]').forEach(function (s) {
        try { var o = JSON.parse(s.textContent || '{}'); for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) mapCache[k] = o[k]; } } catch (e) { /* bad list */ }
      });
      return mapCache;
    };
    var runsOf = function (block) {
      var box = block.querySelector('[data-vt-card-sizes], [data-vt-sizes]');
      var el = box && (box.hasAttribute('data-vt-sizes') ? box : box.querySelector('[data-vt-sizes]'));
      if (el) {
        try { return JSON.parse(el.dataset.vtSizes || '[]'); } catch (e) { return null; }
      }
      var a = block.querySelector('a[href*="/products/"]');
      var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      var entry = m && sizeMap()[decodeURIComponent(m[1])];
      if (!entry) return null;
      // same shape as the card data: [[colour, "36|~37|38"]] ("~" = sold out)
      var inStock = String(entry[0] || '').split('|').filter(Boolean);
      var all = String(entry[1] || '').split('|').filter(Boolean);
      return [['', all.map(function (s) { return inStock.indexOf(s) > -1 ? s : '~' + s; }).join('|')]];
    };
    var cards = function () { return Array.prototype.slice.call(document.querySelectorAll('filter-container .collection-listing product-block')); };
    var inStock = function (block, size) {
      var runs = runsOf(block);
      return !!runs && runs.some(function (run) { return String(run && run[1] || '').split('|').indexOf(size) > -1; });
    };
    var allSizes = function () {
      var seen = {};
      cards().forEach(function (b) {
        (runsOf(b) || []).forEach(function (run) {
          String(run && run[1] || '').split('|').forEach(function (s) { s = s.replace(/^~/, '').trim(); if (s) seen[s] = true; });
        });
      });
      return Object.keys(seen).sort(function (a, b) {
        var na = parseFloat(a), nb = parseFloat(b);
        return (isNaN(na) || isNaN(nb)) ? a.localeCompare(b) : na - nb;
      });
    };
    var applyCards = function () {
      var size = readSizeMemory().shoes;
      var shown = 0;
      cards().forEach(function (b) {
        var ok = !active || !size || inStock(b, size);
        b.classList.toggle('vt-size-hide', !ok);
        if (ok) shown += 1;
      });
      return shown;
    };
    var draw = function () {
      var group = document.querySelector('[data-vt-mysize]');
      var size = readSizeMemory().shoes || '';
      // a real Size filter: offer "Your size" inside it
      if (!group) {
        var sizeGroup = document.querySelector('.vt-fbar__group--size');
        if (!size || !sizeGroup || sizeGroup.querySelector('.vt-fbar__yours')) return;
        var input = Array.prototype.slice.call(sizeGroup.querySelectorAll('input[type="checkbox"]')).filter(function (i) { return i.value === size; })[0];
        if (!input || input.checked || input.disabled) return;
        var yours = document.createElement('button');
        yours.type = 'button';
        yours.className = 'btn btn--secondary vt-fbar__yours';
        yours.textContent = fbarText('mySizeYours', { size: size });
        yours.addEventListener('click', function () {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          announce(tpl(S.showingMySize || '', { size: size }));
        });
        var inPanel = sizeGroup.querySelector('.vt-fbar__panel-in');
        if (inPanel) inPanel.insertBefore(yours, inPanel.firstChild);
        return;
      }
      var sizes = allSizes();
      var withSizes = cards().filter(function (b) { return runsOf(b); }).length;
      if (withSizes < 3 || !sizes.length) { group.hidden = true; return; } // not a shoe list
      group.hidden = false;
      if (active && !size) active = false;
      group.classList.toggle('has-chosen', active);
      var label = group.querySelector('[data-vt-mysize-label]');
      if (label) label.textContent = active ? fbarText('mySizeOn', { size: size }) : fbarText('size');
      var body = group.querySelector('[data-vt-mysize-body]');
      if (!body) return;
      var html = '<p class="vt-mysize__lead">' + esc(size ? fbarText('mySizeYours', { size: size }) : fbarText('mySizePick')) + '</p>';
      html += '<div class="vt-mysize__sizes" role="group" aria-label="' + esc(fbarText('size')) + '">';
      sizes.forEach(function (s) {
        html += '<button type="button" class="vt-mysize__size" data-vt-mysize-pick="' + esc(s) + '" aria-pressed="' + (s === size ? 'true' : 'false') + '">' + esc(s) + '</button>';
      });
      html += '</div>';
      if (size) {
        html += '<button type="button" class="btn btn--secondary vt-mysize__toggle" data-vt-mysize-toggle aria-pressed="' + (active ? 'true' : 'false') + '">' +
          esc(active ? fbarText('mySizeAll') : fbarText('mySizeShow', { size: size })) + '</button>';
      }
      html += '<p class="vt-mysize__note">' + esc(fbarText('mySizeNote')) + '</p>';
      body.innerHTML = html;
    };
    var setActive = function (on, focusSel) {
      active = on;
      remember();
      var n = applyCards();
      draw();
      var size = readSizeMemory().shoes;
      announce(active ? tpl(fbarText('onPage'), { size: size, count: n }) : fbarText('allDone'));
      if (focusSel) {
        var f = document.querySelector(focusSel);
        if (f) f.focus({ preventScroll: true });
      }
    };
    document.addEventListener('click', function (evt) {
      var pick = evt.target.closest && evt.target.closest('[data-vt-mysize-pick]');
      if (pick) {
        core.writeSizeMemory('shoes', pick.dataset.vtMysizePick);
        setActive(true, '[data-vt-mysize-pick="' + (window.CSS && CSS.escape ? CSS.escape(pick.dataset.vtMysizePick) : pick.dataset.vtMysizePick) + '"]');
        return;
      }
      var tog = evt.target.closest && evt.target.closest('[data-vt-mysize-toggle]');
      if (tog) setActive(!active, '[data-vt-mysize-toggle]');
    });
    draw();
    if (active) applyCards();
    document.addEventListener('vt:filterbar:render', draw);
    onListingRefresh(function () { mapCache = null; applyCards(); draw(); });
    document.addEventListener('vt:products:appended', function () { mapCache = null; applyCards(); draw(); });
  }

  /* ---- U10: back to where she was on a collection ----------------------------- */
  var LISTING_KEY = 'vt-listing';
  function initRestoreListing() {
    if (!cfg.restoreListing || !document.body.classList.contains('template-collection')) return;
    if (!document.querySelector('filter-container .collection-listing .product-grid')) return;
    var pages = 0;
    var restoring = false;
    // r10: the address changes when she filters / sorts (Symmetry adds ?filter… / sort_by with history.pushState),
    // so it is read when saving (not once at load), and the "Load more" count starts again with each new list
    var addr = function () { return window.location.pathname + window.location.search; };
    var here = addr();
    document.addEventListener('vt:products:appended', function () { if (!restoring) pages += 1; });
    onListingRefresh(function () { if (!restoring) pages = 0; });
    var save = function () {
      storageSet('sessionStorage', LISTING_KEY, JSON.stringify({ url: addr(), y: Math.round(window.scrollY), pages: pages, t: Date.now() }));
    };
    // saved when she opens a product from the list, and when she leaves the page
    document.addEventListener('click', function (evt) {
      var a = evt.target.closest && evt.target.closest('a[href*="/products/"]');
      if (a && a.closest('filter-container')) save();
    }, true);
    window.addEventListener('pagehide', save);

    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    // r12 (U7): "Continue shopping" in the bag (assets/vt-r12-shop.js) leaves a one-time flag: same place as "back"
    var viaContinue = storageGet('sessionStorage', 'vt-r12-continue') === '1';
    if (viaContinue) storageSet('sessionStorage', 'vt-r12-continue', '0');
    if (!nav || (nav.type !== 'back_forward' && !viaContinue)) return; // the back/forward cache restores the page by itself
    var state;
    try { state = JSON.parse(storageGet('sessionStorage', LISTING_KEY) || 'null'); } catch (e) { state = null; }
    if (!state || state.url !== here || Date.now() - state.t > (viaContinue ? 180 : 30) * 60000) return;
    var want = Math.min(state.pages || 0, 6);
    var goTo = function () { if (state.y > 0) window.scrollTo(0, state.y); };
    if (!want) {
      // after "back" the browser puts her back at the same place by itself; after "Continue shopping" we do
      if (viaContinue) {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        if (document.readyState === 'complete') goTo(); else window.addEventListener('load', goTo, { once: true });
      }
      return;
    }
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    restoring = true;
    var loaded = 0;
    var finish = function () {
      if (!restoring) return;
      restoring = false;
      pages = loaded;
      goTo();
    };
    var next = function () {
      var btn = document.querySelector('[data-vt-load-more]');
      if (!btn || loaded >= want) { finish(); return; }
      var waited = window.setTimeout(function () { document.removeEventListener('vt:products:appended', onDone); finish(); }, 8000);
      var onDone = function () {
        window.clearTimeout(waited);
        document.removeEventListener('vt:products:appended', onDone);
        loaded += 1;
        next();
      };
      document.addEventListener('vt:products:appended', onDone);
      btn.click();
    };
    next();
  }

  /* ---- r9 (T5): filter drawer (phones/tablets) + filter group headings ----------- */
  function initFilterDrawer() {
    var fc = document.querySelector('filter-container');
    if (!fc) return;
    var section = fc.closest('.shopify-section') || document;
    var drawerMq = window.matchMedia ? window.matchMedia('(max-width: 999.98px)') : { matches: false };
    var opener = null;
    var wasOpen = false;
    var panel = function () { return fc.querySelector('.filters'); };
    var isOpen = function () {
      return drawerMq.matches ? fc.classList.contains('filter-container--show-filters-mobile')
        : fc.classList.contains('filter-container--show-filters-desktop');
    };
    var focusables = function (root) {
      return Array.prototype.slice.call(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; })
        .filter(function (el) { return !el.closest('[hidden], .toggle-target--hidden'); });
    };
    var sync = function () {
      var open = isOpen();
      section.querySelectorAll('.toggle-btn[data-toggle-filters]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      var p = panel();
      if (!p) return;
      var drawerOpen = drawerMq.matches && open;
      if (drawerOpen) {
        p.setAttribute('role', 'dialog');
        p.setAttribute('aria-modal', 'true');
        document.documentElement.classList.add('vt-filters-open');
      } else {
        p.removeAttribute('role');
        p.removeAttribute('aria-modal');
        document.documentElement.classList.remove('vt-filters-open');
      }
      setInert(drawerOpen ? p : null);
      if (drawerOpen && !wasOpen) {
        window.setTimeout(function () {
          var close = p.querySelector('.filters__close');
          if (close) close.focus({ preventScroll: true });
        }, 60);
      } else if (!drawerOpen && wasOpen) {
        var active = document.activeElement;
        if (opener && opener.isConnected && (!active || active === document.body || p.contains(active))) opener.focus({ preventScroll: true });
      }
      wasOpen = drawerOpen;
    };
    // r10: while the drawer / sheet is open the rest of the page is inert (no clicks, no Tab, hidden from screen
    // readers) — everything beside the drawer on its way up to <body>, except the shade and the spoken-status box
    var inerted = [];
    var setInert = function (drawer) {
      inerted.forEach(function (el) { el.inert = false; });
      inerted = [];
      if (!drawer || !('inert' in HTMLElement.prototype)) return;
      for (var node = drawer; node && node !== document.body && node.parentElement; node = node.parentElement) {
        Array.prototype.forEach.call(node.parentElement.children, function (sib) {
          if (sib === node || sib.inert || sib.classList.contains('filter-shade')) return;
          if (sib.matches('script, style, link, template, [aria-live], [role="status"], [role="alert"]')) return;
          sib.inert = true;
          inerted.push(sib);
        });
      }
    };
    // remember which "Filter" button opened it (focus goes back there)
    section.addEventListener('click', function (evt) {
      var t = evt.target.closest && evt.target.closest('[data-toggle-filters]');
      if (t && t.classList.contains('toggle-btn')) opener = t;
    }, true);
    new MutationObserver(sync).observe(fc, { attributes: true, attributeFilter: ['class'] });
    if (drawerMq.addEventListener) drawerMq.addEventListener('change', sync);
    sync();
    document.addEventListener('keydown', function (evt) {
      if (!wasOpen) return;
      var p = panel();
      if (!p) return;
      if (evt.key === 'Escape') {
        evt.preventDefault();
        var close = p.querySelector('.filters__close');
        if (close) close.click();
        return;
      }
      if (evt.key !== 'Tab') return;
      var list = focusables(p);
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (!p.contains(document.activeElement)) { evt.preventDefault(); first.focus(); return; }
      if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
      else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
    });

    // group headings (Symmetry <toggle-target>): aria-expanded follows, Space works like Enter
    var syncHeading = function (h) {
      window.setTimeout(function () {
        h.setAttribute('aria-expanded', h.classList.contains('toggle-target-toggler--is-hidden') ? 'false' : 'true');
      }, 0);
    };
    fc.addEventListener('click', function (evt) {
      var h = evt.target.closest && evt.target.closest('toggle-target.filter-group__heading');
      if (h) syncHeading(h);
    });
    fc.addEventListener('keyup', function (evt) {
      var h = evt.target.closest && evt.target.closest('toggle-target.filter-group__heading');
      if (h && evt.key === 'Enter') syncHeading(h);
    });
    fc.addEventListener('keydown', function (evt) {
      var h = evt.target.closest && evt.target.closest('toggle-target.filter-group__heading');
      if (h && (evt.key === ' ' || evt.key === 'Spacebar')) { evt.preventDefault(); h.click(); }
    });
    // the "Filter" and close links are role="button": Space works like Enter
    section.addEventListener('keydown', function (evt) {
      if (evt.key !== ' ' && evt.key !== 'Spacebar') return;
      var b = evt.target.closest && evt.target.closest('a[role="button"][data-toggle-filters]');
      if (b) { evt.preventDefault(); b.click(); }
    });

    // read out the new number of products after filters / sort re-drew the list
    onListingRefresh(function () {
      sync();
      var countEl = document.querySelector('.utility-bar:not(.utility-bar--sticky-mobile-copy) .utility-bar__centre');
      var text = countEl ? countEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!text) {
        // no count shown (e.g. 0 products): read the empty-state title instead
        var emptyEl = fc.querySelector('.collection-listing .vt-empty__title');
        text = emptyEl ? emptyEl.textContent.replace(/\s+/g, ' ').trim() : '';
      }
      announce((CS.updated || '') + (text ? '. ' + text : ''));
    });
  }

  /* ---- r9 (D6): search page — clear button in the big search field ------------------ */
  function initSearchField() {
    document.querySelectorAll('[data-vt-search-clear]').forEach(function (btn) {
      var form = btn.closest('form');
      var input = form && form.querySelector('input[name="q"]');
      if (!input) return;
      var toggle = function () { btn.hidden = !input.value; };
      input.addEventListener('input', toggle);
      btn.addEventListener('click', function () {
        input.value = '';
        toggle();
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.focus();
      });
      toggle();
    });
  }

  /* ---- r9: the products listed on this collection, in order (next / previous on the product page) ---- */
  var ORDER_KEY = 'vt-listing-order';
  function saveListingOrder() {
    if (CC.kind !== 'collection' || !CC.handle) return;
    var seen = {};
    var items = [];
    document.querySelectorAll('filter-container .collection-listing [data-vt-listing] product-block').forEach(function (block) {
      if (block.classList.contains('vt-size-hide')) return;
      var a = block.querySelector('.product-block__detail a.product-link') || block.querySelector('a.product-link');
      var href = a ? a.getAttribute('href') || '' : '';
      var m = href.match(/\/products\/([^/?#]+)/);
      if (!m || seen[m[1]]) return;
      seen[m[1]] = true;
      var title = block.querySelector('.product-block__title');
      items.push({ handle: decodeURIComponent(m[1]), url: href.split('#')[0], title: title ? title.textContent.trim() : '' });
    });
    if (!items.length) return;
    storageSet('sessionStorage', ORDER_KEY, JSON.stringify({
      handle: CC.handle, title: CC.title || '', url: window.location.pathname + window.location.search, items: items
    }));
  }
  function initListingOrder() {
    if (CC.kind !== 'collection') return;
    saveListingOrder();
    document.addEventListener('vt:products:appended', saveListingOrder);
    onListingRefresh(saveListingOrder);
  }

  /* ---- r11 (U7): the phone "sticky" copy of the count bar (Symmetry clones it once) keeps the Filter count and the
     "Clear filters" link up to date after filters change (Symmetry only refreshes its middle part) ---------------- */
  function initStickyBarSync() {
    onListingRefresh(function () {
      var from = document.querySelector('.utility-bar:not(.utility-bar--sticky-mobile-copy) .utility-bar__left');
      var to = document.querySelector('.utility-bar--sticky-mobile-copy .utility-bar__left');
      if (from && to && to.innerHTML !== from.innerHTML) to.innerHTML = from.innerHTML;
    });
  }

  /* ------------------------------------------------------------------ boot */
  core.onReady(function () {
    initStickyBarSync();
    initGridSwitch();
    initLoadMore();
    initFilterBar(); // r10 (before the size helper: its clicks redraw the Size panel)
    initSizeChip();
    // round 7
    initRestoreListing();
    // round 9
    initFilterDrawer();
    initSearchField();
    initListingOrder();
    // after Symmetry re-renders the list (filters / sort): keep her 1 / 2 per row choice
    onListingRefresh(function () {
      var mode = storageGet('localStorage', GRID_KEY);
      if (mode) applyGridMode(mode);
    });
  });
})();
